import { render, staticRenderFns } from "./IntegrationSingleDetails.vue?vue&type=template&id=ebbd7a2c&"
import script from "./IntegrationSingleDetails.vue?vue&type=script&lang=js&"
export * from "./IntegrationSingleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports